import { render, staticRenderFns } from "./DonutsChart.vue?vue&type=template&id=702a659c&"
import script from "./DonutsChart.vue?vue&type=script&lang=js&"
export * from "./DonutsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports